import React, { useState, useEffect, useContext  } from "react";
import logo from '../Images/logo.png'; 
import VisaLogo from '../Images/visa.png'; // Make sure to have these logos in your project
import MasterCardLogo from '../Images/mastercard.png';
import MaestroLogo from '../Images/maestro.png';
import AmericanExpressLogo from '../Images/American_Express.png';
import LoginModal from '../Components/LoginModal';
import { AuthContext } from '../Components/AuthContext';
import { Link } from 'react-router-dom';



const Footer = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [footerDescription, setFooterDescription] = useState('');
  const { token } = useContext(AuthContext);

  const handleLoginSuccess = () => {
    setIsModalVisible(false); // Close the modal on successful login
  };

  // Fetch footer description from API
  useEffect(() => {
    const fetchFooterDescription = async () => {
      try {
        const response = await fetch(
          "https://backend.printtrio.co.uk/api/home/get-setting"
        );
        const data = await response.json();
        if (response.ok && data.success) {
          const description = data.data[0]?.footer_description || "No description available.";
          setFooterDescription(description);
        } else {
          console.error("Failed to fetch footer description:", data.errors);
          setFooterDescription("Failed to load footer description.");
        }
      } catch (error) {
        console.error("Error fetching footer description:", error);
        setFooterDescription("An error occurred while loading the footer description.");
      }
    };

    fetchFooterDescription();
  }, []);


  return (
    <div>
   <footer className="bg-[#F4F4F4] flex flex-col xl:flex-row justify-between  px-8 xl:px-28 py-10 md:py-16 gap-8 xl:gap-28 max-w-screen-xl mx-auto px-4 xl:px-20 relative">
        <div className="space-y-4 w-full  xl:w-1/3 ">
        <Link to="/">
          <img src={logo} alt="Logo" className="h-12 mx-auto xl:mx-0 mb-0 md:mb-10 xl:mb-0" />
          </Link>
          <p className="text-gray-500 text-xs text-center px-0 md:px-20 xl:px-0 xl:text-left">
             {footerDescription}
          </p>
        </div>


        <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-12">
          {/* <div className="space-y-4 text-md">
            <h3 className="text-gray-900 font-bold">About Us</h3>
            <nav>
    <ul className="space-y-2 text-sm">
      <li><a href="/history" className="text-gray-600 hover:text-gray-900 transition">History</a></li>
      <li><a href="/certificates" className="text-gray-600 hover:text-gray-900 transition">Certificates</a></li>
      <li><a href="/awards" className="text-gray-600 hover:text-gray-900 transition">Our Awards</a></li>
      <li><a href="/environment" className="text-gray-600 hover:text-gray-900 transition">Environment</a></li>
      <li><a href="/plant-list" className="text-gray-600 hover:text-gray-900 transition">Plant List</a></li>
    </ul>
  </nav>
          </div> */}
          <div className="space-y-4 text-md">
            <h3 className="text-gray-900 font-bold">Help</h3>
            <nav>
    <ul className="space-y-2 text-sm">
      {/* <li><a href="/delivery" className="text-gray-600 hover:text-gray-900 transition">Delivery Information</a></li> */}
      <li><a href="/Help-and-support" className="text-gray-600 hover:text-gray-900 transition">FAQs</a></li>
    </ul>
  </nav>
          </div>
          <div className="space-y-4 text-md">
            <h3 className="text-gray-900 font-bold">Contact Us</h3>
            <nav>
    <ul className="space-y-2 text-sm">
      {/* <li><a href="/concern" className="text-gray-600 hover:text-gray-900 transition">Concern</a></li>
      <li><a href="/products" className="text-gray-600 hover:text-gray-900 transition">Free Products</a></li> */}
      <li><a href="/contact" className="text-gray-600 hover:text-gray-900 transition">Contact Us</a></li>
      <li><a href="/FreeQuote" className="text-gray-600 hover:text-gray-900 transition">Get a Free Quote</a></li>
      {/* <li><a href="/contact" className="text-gray-600 hover:text-gray-900 transition">Get a Free Quote</a></li> */}
    </ul>
  </nav>
          </div>
          <div className="space-y-4 text-md">
            <h3 className="text-gray-900 font-bold">Art Work</h3>
            <nav>
    <ul className="space-y-2 text-sm">
      {/* <li><a href="/design-service" className="text-gray-600 hover:text-gray-900 transition">Artwork Design Service</a></li> */}
      {/* <li><a href="/create" className="text-gray-600 hover:text-gray-900 transition">Create Your Own</a></li> */}
      <li><a href="/SupplyingArtwork" className="text-gray-600 hover:text-gray-900 transition">Supplying Artwork</a></li>
      {/* <li><a href="/sizes" className="text-gray-600 hover:text-gray-900 transition">Printing Paper Sizes</a></li>
      <li><a href="/templates" className="text-gray-600 hover:text-gray-900 transition">Templates</a></li> */}
    </ul>
  </nav>
          </div>
          { !token && (
          <div className="space-y-4 text-md">
            <h3 className="text-gray-900 font-bold">My Account</h3>
            <nav>
    <ul className="space-y-2 text-sm">
      <li>
        <button  
      className="text-gray-600 hover:text-gray-900 transition"
      onClick={() => setIsModalVisible(true)}
      >Login / Register
      </button >
      </li>
      {/* <li><a href="/register" className="text-gray-600 hover:text-gray-900 transition">Register</a></li> */}
      {/* <li><a href="/delivery-info" className="text-gray-600 hover:text-gray-900 transition">Delivery Information</a></li> */}
      {/* <li><a href="/" className="text-gray-600 hover:text-gray-900 transition">Trackable Delivery</a></li> */}
      {/* <li><a href="/white-label" className="text-gray-600 hover:text-gray-900 transition">White Label</a></li> */}
      {/* <li><a href="/payment-queries" className="text-gray-600 hover:text-gray-900 transition">Payment Queries</a></li> */}
    </ul>
  </nav>
          </div>
          )}
          </div>
     
    </footer>



    <div className=" mx-auto flex flex-col md:flex-row justify-between items-center px-24 md:px-8 xl:px-28 mb-5 text-center md:text-left mt-5 max-w-screen-xl mx-auto px-4 xl:px-20 relative">
        <div className="text-gray-600 text-xs mb-4 md:mb-0">
        ©{new Date().getFullYear()} printtrio. All Rights Reserved.
        <br />
         <span >Powered & Developed By</span>
  <a 
    href="https://www.qtechnetworks.com/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="text-blue-500 hover:underline ml-1"
  >
    QTech
  </a>
        </div>
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-4">
          <a href="/privac-policy" className="text-gray-600 hover:text-gray-900 transition-colors text-xs">Privacy & Policy</a>
          <a href="/terms-conditions" className="text-gray-600 hover:text-gray-900 transition-colors text-xs">Terms & Condition</a>
          <img src={MasterCardLogo} alt="MasterCard" className="h-6" />
          <img src={VisaLogo} alt="Visa" className="h-6" />
          <img src={AmericanExpressLogo} alt="American Express" className="h-6" />
          <img src={MaestroLogo} alt="Maestro" className="h-6" />
        </div>
      </div>
      <LoginModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
};

export default Footer;
